/**
 * Check if provided variable is a real object.
 * 
 * @param {*} obj
 * @returns {boolean}
 */
export default function isObject( obj ) {
	return obj != null && obj.constructor.name === "Object";
}
